import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "overlay", "panel", "summary"]

  confirm(event) {
    event.preventDefault()
    this.pendingForm = event.target.closest("form")

    const outcomeInput = this.pendingForm.querySelector("[name=outcome]")
    if (outcomeInput && !outcomeInput.value) {
      const outcomeSection = outcomeInput.closest("div")
      outcomeSection.classList.add("ring-2", "ring-inset", "ring-red-500", "rounded-lg", "shake")
      setTimeout(() => outcomeSection.classList.remove("ring-2", "ring-inset", "ring-red-500", "rounded-lg", "shake"), 2000)
      return
    }

    if (this.hasSummaryTarget) {
      this.summaryTarget.innerHTML = this.buildSummary()
    }

    this._animateIn()
  }

  proceed() {
    this._animateOut(() => {
      if (this.pendingForm) this.pendingForm.requestSubmit()
    })
  }

  cancel() {
    this._animateOut(() => { this.pendingForm = null })
  }

  _animateIn() {
    this.dialogTarget.classList.remove("hidden")
    this.dialogTarget.classList.add("flex")
    this.dialogTarget.offsetHeight
    this.overlayTarget.classList.add("overlay-enter")
    this.overlayTarget.classList.remove("overlay-hidden")
    this.panelTarget.classList.add("panel-enter")
    this.panelTarget.classList.remove("panel-hidden")
  }

  _animateOut(callback) {
    this.overlayTarget.classList.remove("overlay-enter")
    this.overlayTarget.classList.add("overlay-hidden")
    this.panelTarget.classList.remove("panel-enter")
    this.panelTarget.classList.add("panel-hidden")

    if (this.prefersReducedMotion) {
      this._afterClose()
      if (callback) callback()
    } else {
      this.panelTarget.addEventListener("transitionend", () => {
        this._afterClose()
        if (callback) callback()
      }, { once: true })
    }
  }

  _afterClose() {
    this.dialogTarget.classList.add("hidden")
    this.dialogTarget.classList.remove("flex")
  }

  buildSummary() {
    const form = this.pendingForm
    if (!form) return ""

    const tradeType = form.querySelector("[name=trade_type]")?.value
    const outcome = form.querySelector("[name=outcome]")?.value

    const typeLabel = tradeType === "buy" ? "Comprar" : "Vender"
    const outcomeLabel = outcome === "yes" ? "Sí" : "No"

    return `<p>${typeLabel} en <strong>${outcomeLabel}</strong></p>
            <p class="text-xs text-amber-400 mt-2">El precio final puede variar ligeramente respecto a la cotización mostrada.</p>`
  }

  get prefersReducedMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches
  }
}
